import { combineReducers } from 'redux';

import authUser from './auth/reducer';
import menu from './menu/reducer';
import settings from './settings/reducer';

const reducers = combineReducers({
  menu,
  settings,
  authUser,
});

export default reducers;
